export default {
  dataModel: {
    types: ['pair:Organization', 'pair:Place'],
    list: {
      containers: {
        oasis: ['/organizations', '/places']
      }
    }
  }
};
